module.exports = __webpack_public_path__ + "static/img/order_icon5.aeef40cb.svg";